module.exports = __webpack_public_path__ + "static/media/single-loan-placeholder.7cf4b9ee.svg";